import {TextButton} from "@/components/form/TextButton";
import {useLogout} from "@/auth/useLogout";
import {useTranslation} from 'react-i18next';

export function LogoutButton() {
    const {t} = useTranslation();
    const {logout} = useLogout();

    return (
        <TextButton title={t('auth.logout.button')} onPress={logout} />
    );
}
